import { render, staticRenderFns } from "./Associates.vue?vue&type=template&id=27e9ddfe&"
import script from "./Associates.vue?vue&type=script&lang=js&"
export * from "./Associates.vue?vue&type=script&lang=js&"
import style0 from "./Associates.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports